import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./Store/store";
import { AuthProvider } from "react-oidc-context";
import {cognitoAuthConfig} from "./config/awsConfig";

const root = ReactDOM.createRoot(document.getElementById('root'));
window.store = store;

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
    <Provider store={store}>
      <App/>
    </Provider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
